
var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = new Model({
	name: "activelivechatsession",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	recalculate: recalculate
});

function init(){
	this._activeSessions = [];
	this._historySessions = [];
	this._pendingSessions = [];
	this.push(null);
}

function uninit(){
	this._viewing = null;
	this._activeSessions = null;
	this._historySessions = null;
	this._pendingSessions = null;
}

function listeners(){
	return {
		"livechatsessions:updated": handle_active_sessions_updated,
		"livechatsessionhistory:updated": handle_history_sessions_updated,
		"livechatsessionpending:updated": handle_pending_sessions_updated
	};
}

function triggers(){
	return {
		view: view,
		reset: reset
	};
}

function recalculate(){
	var activeSessions = this._activeSessions;
	var historySessions = this._historySessions;
	var pendingSessions = this._pendingSessions;
	var sessions = activeSessions.concat(historySessions, pendingSessions);
	var current = this._viewing;

	if(!current) return;

	var newSessionData = xtend(current, findSession(current._id, sessions));

	this._viewing = newSessionData;
	this.push(newSessionData);
}

function view(data){
	var session = data.session;
	var activeSessions = this._activeSessions;
	var historySessions = this._historySessions;
	var pendingSessions = this._pendingSessions;
	var sessions = activeSessions.concat(historySessions, pendingSessions);

	var sessionData = findSession(session, sessions);
	if(!sessionData) return;

	this._viewing = sessionData;
	this.push(sessionData);
	this.dispatch("viewing", sessionData);

	this.emit("usermetrics:trigger:track", "view livechat session", {
		session: sessionData._id
	});
}

function reset(){
	this.emit("usermetrics:trigger:track", "close livechat session", {
		session: this._viewing._id
	});
	this._viewing = null;
	this.push(null);
}

function findSession(session, sessions){
	return sessions.reduce(function(acc, data){
		if(data._id === session) acc = data;
		return acc;
	}, undefined);
}

function handle_active_sessions_updated(data){
	var list = data.list;
	this._activeSessions = list;
	this.recalculate();
}

function handle_history_sessions_updated(data){
	var list = data.list;
	this._historySessions = list;
	this.recalculate();
}

function handle_pending_sessions_updated(data){
	var list = data.list;
	this._pendingSessions = list;
	this.recalculate();
}
